import { Connect, Message, SocketObservable } from '@genesislcap/foundation-comms';
import { DI } from '@microsoft/fast-foundation';
import { ICompanyApproval } from '../types';

export interface IAutoExecuteApprovedCounterpartiesService {
  getAutoExecuteApprovedCounterpartiesByCascadeCompany(): Promise<Message<any>>;
  streamAutoExecuteApprovedCounterpartiesByCascadeCompany(): SocketObservable<Message<any>>;
  upsertAutoExecuteApprovedCounterparties(autoExecuteApprovedCounterparties: any[]);
}

class AutoExecuteApprovedCounterpartiesServiceImpl
  implements IAutoExecuteApprovedCounterpartiesService
{
  constructor(@Connect private connect: Connect) {}

  getAutoExecuteApprovedCounterpartiesByCascadeCompany(): Promise<Message<any>> {
    return this.connect.snapshot('AUTO_EXECUTE_APPROVED_COUNTERPARTIES', {});
  }

  streamAutoExecuteApprovedCounterpartiesByCascadeCompany(): SocketObservable<Message<any>> {
    const request: any = this.connect.stream(
      'AUTO_EXECUTE_APPROVED_COUNTERPARTIES',
      (streamMessage: Message) => {
        () => {};
      },
      (x) => {}
    );

    return request;
  }

  public async upsertAutoExecuteApprovedCounterparties(
    autoExecuteApprovedCounterparties: Array<ICompanyApproval>
  ) {
    if (!autoExecuteApprovedCounterparties) {
      return;
    }

    const request: any = await this.connect.commitEvent(
      'EVENT_AUTO_EXECUTE_APPROVED_COUNTERPARTIES_UPSERTS',
      {
        DETAILS: {
          COMPANY_APPROVALS: autoExecuteApprovedCounterparties,
        },
        IGNORE_WARNINGS: true,
        VALIDATE: false,
      }
    );

    return request;
  }
}

export const IAutoExecuteApprovedCounterpartiesService =
  DI.createInterface<IAutoExecuteApprovedCounterpartiesService>((x) =>
    x.singleton(AutoExecuteApprovedCounterpartiesServiceImpl)
  );
